// trace-histograms.js

import moment from "moment";
import { put, call, takeLatest } from "redux-saga/effects";

import { encodeUrl, getWithStatusCheck } from "../helpers/fetch.js";

// histograms: [{
//   timestamp: 1233542345,
//   histogram: {
//     69: 4,    // bucket: count
//     168: 29,  // `bucket` is the `ceil(duration)` for the traces in a bucket
//     267: 2,   // `count` is # of traces at or below that threshold, but above previous
//     ...
//   }
// }]

export const INITIAL_STATE = {
  histograms: [],
  isFetching: false,
};

// action types
const FETCH = "trace-web/trace-histograms/FETCH";
const FETCH_SUCCESS = "trace-web/trace-histograms/FETCH_SUCCESS";
const FETCH_FAILURE = "trace-web/trace-histograms/FETCH_FAILURE";

// reducer
const traceHistogramsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_SUCCESS:
      return {
        ...state,
        histograms: action.histograms,
        isFetching: false,
      };
    case FETCH_FAILURE:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
export default traceHistogramsReducer;

// action creators
export const fetchTraceHistograms = (
  start,
  end,
  orgId,
  svcId,
  histogramType,
  filterBy
) => {
  return {
    type: FETCH,
    start,
    end,
    orgId,
    svcId,
    histogramType,
    filterBy,
  };
};

export const fetchSuccess = response => {
  return {
    type: FETCH_SUCCESS,
    histograms: response.traces,
  };
};

export const fetchFailure = ex => {
  return {
    type: FETCH_FAILURE,
    ex,
  };
};

// saga
export function* traceHistogramsWatcher() {
  yield takeLatest(FETCH, traceHistogramsWorker);
}

export function* traceHistogramsWorker(action) {
  try {
    let params = {
      start_time: moment(action.start).unix(),
      end_time: moment(action.end).unix(),
      type: action.histogramType,
    };

    // optional parameters
    if (action.filterBy && Object.keys(action.filterBy).length > 0) {
      params = {
        ...params,
        ...action.filterBy,
      };
    }

    const url = encodeUrl(
      `/v1/apm/services/${action.svcId}/traces/histograms`,
      params
    );
    const json = yield call(getWithStatusCheck, url);
    yield put(fetchSuccess(json));
  } catch (err) {
    yield put(fetchFailure(err));
  }
}
